"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = exports.Partners = exports.HeroButton = exports.CompanyCTA = exports.BottomPartners = exports.Content = exports.Boxes = exports.Headline = exports.Hero = exports.Wrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const elements_1 = require("@src/components/elements");
const actions_1 = __importDefault(require("@src/actions"));
const CompaniesListPreview_1 = require("@src/components/modules/global/CompaniesList/CompaniesListPreview");
const polished_1 = require("polished");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const HomeSearchWrapper_1 = require("./HomeSearchWrapper");
const BoxQuickstart_1 = require("./BoxQuickstart");
const BOXES_TOP_MARGIN = '220px';
exports.Wrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;
exports.Hero = styled_components_1.default.div `
	padding-top: ${props => props.theme.size.headerHeight}px;
	width: 100%;
	height: 900px;
	position: relative;
	background: url('/media/images/hero-homepage-desaturated.jpg');
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	display: flex;
	align-items: center;
	${(0, styled_breakpoints_1.up)('md')} {
		height: 760px;
	}
	${(0, styled_breakpoints_1.up)('lg')} {
		height: 720px;
	}
	&:after {
		content: '';
		display: block;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		position: absolute;
		z-index: 0;
		pointer-events: none;
		opacity: 0.9;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		transform: rotate(180deg);
	}
`;
exports.Headline = styled_components_1.default.div `
	position: relative;
	z-index: 1;
	text-align: center;
	padding: 0 2em ${BOXES_TOP_MARGIN};

	& > * {
		color: ${props => props.theme.color.white};
	}
	h1 {
		font-size: 2.4em;
		font-weight: bold;
		margin-bottom: 0.5em;
	}
	h2 {
		font-size: 1.4em;
		font-weight: 200;
		line-height: 1.4;
		padding-bottom: 2em;

		strong {
			font-weight: 700;
		}
	}
`;
exports.Boxes = styled_components_1.default.div `
	width: 100%;
	position: relative;
	z-index: 1;
	display: flex;
	align-items: flex-start;
	margin-top: -${BOXES_TOP_MARGIN};
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('md')} {
		flex-direction: row;
	}
`;
exports.Content = styled_components_1.default.div `
	width: 100%;
	background: ${({ theme }) => theme.color.gray2};
`;
exports.BottomPartners = styled_components_1.default.div `
	width: 100%;
	background: ${props => props.theme.color.white};
	padding: 5em 0;
	text-align: center;

	h2 {
		color: ${props => props.theme.color.brand4};
		font-size: 2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
exports.CompanyCTA = styled_components_1.default.div `
	width: 100%;
	font-weight: 400;
	font-size: 0.9em;
	padding: 2em 2em 0;
	display: block;

	a,
	a:focus,
	a:link,
	a:visited {
		color: ${props => (0, polished_1.transparentize)(0.3, props.theme.color.white)};
	}

	a:hover {
		text-decoration: underline;
	}

	strong {
		color: ${props => props.theme.color.white};
	}
`;
exports.HeroButton = (0, styled_components_1.default)(elements_1.Button) `
	${(0, styled_breakpoints_1.up)('sm')} {
		transform: scale(1.2);
	}
`;
exports.Partners = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	a {
		padding: 0 0 2em 0;
		width: 100%;
		${(0, styled_breakpoints_1.up)('sm')} {
			width: 50%;
		}
		${(0, styled_breakpoints_1.up)('md')} {
			width: 30%;
		}
		${(0, styled_breakpoints_1.up)('lg')} {
			width: 25%;
		}
	}
`;
const Home = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const location = (0, react_router_dom_1.useLocation)();
    react_1.default.useEffect(() => {
        if (location.pathname === '/offer_feedback') {
            dispatch(actions_1.default.offerFeedbackStart());
        }
    }, []);
    const { data: partners } = (0, useSSRFetch_1.useSSRFetch)(useSSRFetch_1.SSRFetchConfig.partners.key);
    return ((0, jsx_runtime_1.jsxs)(exports.Wrapper, { children: [(0, jsx_runtime_1.jsx)(elements_1.Head, { id: "home", customSocialTitle: true }), (0, jsx_runtime_1.jsx)(exports.Hero, { children: (0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsxs)(exports.Headline, { children: [(0, jsx_runtime_1.jsx)("h1", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.hero.headline" }) }), (0, jsx_runtime_1.jsxs)("h2", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.hero.subheadline1", values: {
                                            strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                                        } }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.hero.subheadline2" })] }), (0, jsx_runtime_1.jsx)(HomeSearchWrapper_1.HomeSearchWrapper, {}), (0, jsx_runtime_1.jsx)(exports.CompanyCTA, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/firmy", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "home.hero.cta_company", values: {
                                            strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                                        } }) }) })] }) }) }), (0, jsx_runtime_1.jsxs)(exports.Content, { children: [(0, jsx_runtime_1.jsx)(elements_1.Holder, { children: (0, jsx_runtime_1.jsx)(exports.Boxes, { children: (0, jsx_runtime_1.jsx)(BoxQuickstart_1.BoxQuickstart, {}) }) }), (0, jsx_runtime_1.jsx)(CompaniesListPreview_1.CompaniesListPreview, {})] })] }));
};
exports.Home = Home;
